import { claveFechaDia } from "../../../../Components/fmtFechaDia";

// Pasos del asistente (el índice es el `paso` que se guarda en el proceso).
export const PASOS = [
  { titulo: "Ejercicio", descripcion: "Año, corte e incidencias" },
  { titulo: "Aplicación", descripcion: "Ordinaria o extraordinaria" },
  { titulo: "Empleados", descripcion: "Días e importes" },
  { titulo: "Conceptos", descripcion: "Revisión y alta" },
  { titulo: "Resumen", descripcion: "ISR, impresión y aplicar" },
];

export const fmtMXN = (n) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(n || 0);

export const redondear2 = (n) => Math.round((Number(n) || 0) * 100) / 100;

// Fecha-día del backend (anclada al mediodía UTC) → "DD/MM/YYYY".
export const fechaTxt = (f) => {
  const k = claveFechaDia(f);
  return k ? k.split("-").reverse().join("/") : "";
};

// Misma fórmula que Utils/aguinaldo/propuestaAguinaldo.utils.js (calcularImporte).
export const calcularImporte = (diasAguinaldo, diasAnio, diasTrabajados, salarioDiario) =>
  redondear2(
    (Number(diasAguinaldo) / (Number(diasAnio) || 365)) *
      (Number(diasTrabajados) || 0) *
      (Number(salarioDiario) || 0)
  );

// Días de aguinaldo que se pagan: los de la tabla, en proporción a los días trabajados del año.
// Sólo para mostrar (4 decimales); el importe se calcula sin redondear este paso.
export const diasProporcionales = (diasAguinaldo, diasAnio, diasTrabajados) =>
  Math.round(((Number(diasAguinaldo) * (Number(diasTrabajados) || 0)) / (Number(diasAnio) || 365)) * 10000) / 10000;

// Fracción del año trabajada, como porcentaje.
export const fmtProporcion = (diasTrabajados, diasAnio) =>
  `${(((Number(diasTrabajados) || 0) / (Number(diasAnio) || 365)) * 100).toFixed(2)} %`;

export const fmtDias = (n, decimales = 4) =>
  (Number(n) || 0).toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: decimales });

// La fila entra al aguinaldo (mismo criterio que empleadosAIncluir en el backend).
export const filaIncluida = (e) => e.incluido && !e.noAplicable && Number(e.importe) > 0;

// El ISR simulado sigue valiendo mientras el importe no haya cambiado después de calcularlo.
export const isrVigente = (e) =>
  !!e.simulacion?.calculadoEn && redondear2(e.simulacion.importeBase) === redondear2(e.importe);

export const ESTADO_VERIFICACION = {
  correcto: { texto: "Correcto", color: "#52c41a" },
  crear: { texto: "Se dará de alta", color: "#00BFD6" },
  corregir: { texto: "Se corregirá", color: "#d48806" },
  revisar: { texto: "Revisar a mano", color: "#cf1322" },
  aviso: { texto: "Aviso", color: "#8c8c8c" },
};
